"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.record = record;
const util_utf8_1 = require("@smithy/util-utf8");
const utils_1 = require("@aws-amplify/core/internals/utils");
const core_1 = require("@aws-amplify/core");
const utils_2 = require("../utils");
const utils_3 = require("../../../utils");
const logger = new core_1.ConsoleLogger('KinesisFirehose');
function record(...args) {
    const [ctx, input] = (0, utils_1.resolveCtxArgs)(args);
    const { streamName, data } = input;
    if (!(0, utils_3.isAnalyticsEnabled)()) {
        logger.debug('Analytics is disabled, event will not be recorded.');
        return;
    }
    const timestamp = Date.now();
    const { region, bufferSize, flushSize, flushInterval, resendLimit } = (0, utils_2.resolveConfig)(ctx);
    (0, utils_3.resolveCredentials)(ctx)
        .then(({ credentials, identityId }) => {
        const buffer = (0, utils_2.getEventBuffer)({
            region,
            credentials,
            identityId,
            bufferSize,
            flushSize,
            flushInterval,
            resendLimit,
            userAgentValue: (0, utils_3.getAnalyticsUserAgentString)(utils_1.AnalyticsAction.Record),
        });
        buffer.append({
            region,
            streamName,
            event: ArrayBuffer.isView(data) ? data : (0, util_utf8_1.fromUtf8)(JSON.stringify(data)),
            timestamp,
            retryCount: 0,
        });
    })
        .catch(e => {
        logger.warn('Failed to record event.', e);
    });
}
